module.exports = __webpack_public_path__ + "img/Temperus_island.2629c20e.png";